import { render, staticRenderFns } from "./PermPage.vue?vue&type=template&id=60d07c5e"
import script from "./PermPage.vue?vue&type=script&lang=js"
export * from "./PermPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports